// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"29eea808","193":"aa194cd7","215":"02dc4c73","236":"749f8431","317":"dc668ca9","423":"3caaa625","453":"473940cb","651":"7f73d019","726":"da873dd7","745":"63d18157","893":"6c517d71","924":"3e4a3ae3"}[chunkId] + ".chunk.js";
};